import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import AccountPageToolBar from '../../../components/admin_portal/account/AccountPageToolBar';
import Account from '../../../components/admin_portal/account/Account';
import { isAuth } from '../../../helpers/cookies';
import { SUPER_ADMIN, ADDNECTAR_ADMIN } from '../../../helpers/constants';

class AccountContainer extends Component {
  componentDidMount() {
    if ([SUPER_ADMIN, ADDNECTAR_ADMIN].includes(isAuth().role)) {
      this.props.get_company_list({ limit: 100 });
    }
    this.props.get_company_process();
  }

  handleAccountModal = (newVal, c_action) => {
    this.props.setAccountModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleAccountUpdateModal = async (newVal, c_action, user_id) => {
    let res = await this.props.get_user_details(user_id)
    if (res && !res.error) {
      this.props.setAccountModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(user_id)
    }
  };

  handleAccountSubmit = async (payload) => {
    let res = await this.props.create_account(payload);
    return res;
  };

  handleAccountUpdate = async (payload) => {
    let res = await this.props.update_account(payload);
    return res;
  };

  handleActivateDeactivateUsers = async (payload) => {
    let res = await this.props.activate_deactivate_users(payload);
    return res;
  };

  render() {
    const {
      is_account_modal_open,
      total_users_count,
      common_loading,
      page,
      c_action,
      user_id,
      selected_data,
      company_process
    } = this.props;

    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: AccountPageToolBar,
      }} title={""} sx={{
        '& .css-lc31tn > .MuiTypography-h4': {
          fontSize: '14px',
          alignSelf: { md: 'center', xs: 'flex-start' },
        },
        '& .css-lc31tn': {
          bgcolor: theme => theme.palette.grey[200],
          px: 1.5,
          py: 0.1,
          borderRadius: '10px',
          my: 1.5,
          flexDirection: { md: 'row', xs: 'column' },
          alignItems: { md: 'unset', xs: 'flex-start' }
        },
        '& .css-1hwxlk6': {
          width: { md: 'unset', xs: '100%' },
          flexDirection: { md: 'row', xs: 'column' },
          marginLeft: { md: 'auto', xs: 'unset!important' }
        },
      }}>
        <Account
          total_users_count={total_users_count}
          is_loading={common_loading}
          page={page}
          is_account_modal_open={is_account_modal_open}
          user_id={user_id}
          c_action={c_action}
          company_process={company_process}
          selected_data={selected_data}
          handleAccountModal={this.handleAccountModal}
          handleAccountSubmit={this.handleAccountSubmit}
          handleAccountUpdate={this.handleAccountUpdate}
          handleActivateDeactivateUsers={this.handleActivateDeactivateUsers}
          handleAccountUpdateModal={this.handleAccountUpdateModal}
        />
      </PageContainer>
    )
  }
}

export default AccountContainer;
